export var getInitialCache = function getInitialCache(params) {
  return {
    isFirstLoad: true,
    options: [],
    hasMore: true,
    isLoading: false,
    additional: params.additional
  };
};